module.exports = __webpack_public_path__ + "img/news_hola_hover.1a46e93c.svg";